define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.getRouteAttr = exports.isEntityCreateRoute = exports.isEntityRoute = exports.EntityCreateSaveRouteRegex = exports.EntityCreateRouteRegex = exports.EntityRouteRegex = void 0;
    exports.EntityRouteRegex = /(tp|gp|hp|ga|f|wa|scr|sma|pr)\/\d+(\d+)?/i;
    exports.EntityCreateRouteRegex = /(tp|gp|hp|ga|f|wa|scr|sma|pr)(\/\w+)?\/create/i;
    exports.EntityCreateSaveRouteRegex = /(tp|gp|hp|ga|f|wa|scr|sma|pr)(\/\w+)?\/create\/save/i;
    function isEntityRoute(path) {
        return exports.EntityRouteRegex.test(path);
    }
    exports.isEntityRoute = isEntityRoute;
    function isEntityCreateRoute(path) {
        return exports.EntityCreateRouteRegex.test(path);
    }
    exports.isEntityCreateRoute = isEntityCreateRoute;
    function getRouteAttr(attributes, key) {
        for (let k of Object.keys(attributes || {})) {
            if (k.toLowerCase() == key.toLowerCase()) {
                return attributes[k];
            }
        }
        return null;
    }
    exports.getRouteAttr = getRouteAttr;
});
